<div class="payment-options">
  <ul class="list-inline">
    <div class="option-link" href="javascript:void(0)" *ngFor="let item of options">
      <span class="option-icons" (click)="upiOnClick(item, paymentModule, amountForm)" [ngStyle]="{'background-position': item.position}" matRipple data-bg="../assets/images/payment-modes.png"></span>
      <span class="option-name">{{item.label}}</span>
    </div>
  </ul>
</div>

<ng-template #paymentModule>
  <app-module-loader [load]="vars.fundraiser" moduleId="payment-module" selector="app-main-payment" [inputs]="{
    internal: true,
    fundraiser: vars.fundraiser,
    origin: origin,
    showBeneficiary: false,
    type: 'full',
    isBtnClicked: isBtnClicked,
    upiMode: mode,
    tagLabel: tagLabel,
    recommendTag: recommendTag,
    theme: theme
    }">
  </app-module-loader>
</ng-template>

<ng-template #amountForm>
  <app-payment-otd [InputConfig]="{
      label: 'Stories.donations.makeDonation' | translatePipe | async,
      fundraiser: vars.fundraiser,
      slabTheme: 'slab-theme-v5',
      paymentBtnClass: 'payment-btn-theme-v3',
      origin: origin,
      recentPayMode: {payment_mode: this.mode.mode, payment_mode_value: this.mode.value},
      showSlabs: true,
      donatingAs: true,
      onpage: false
    }">
  </app-payment-otd>
</ng-template>